export const formatAppointmentSubmission = (selectedSlot)=>{
    if (!selectedSlot?.startDate || !selectedSlot?.endDate || !selectedSlot?.timeZone) {
        return null;
    }
    return {
        startDate: selectedSlot?.startDate,
        endDate: selectedSlot?.endDate,
        timeZone: selectedSlot?.timeZone
    };
};

//# sourceMappingURL=index.js.map